export default {
    org: "uVerifi",
    orgColors: {
        darkOrange: "#e26b27",
        mediumOrange: "#f3c1a5",
        lightOrange: "#fdf5f0",
        darkGray: "#2C2E2F",
        mediumGray: "#babfc3",
        lightGray: "#e2e4e5",
        darkYellow: "#ffc600",
        mediumYellow: "#fee382",
        lightYellow: "#fef0b8"
    },
    palette: {
        background: {
            default: "#fff"
        },
        error: {
            main: "#ee315e"
        },
        primary: {
            main: "#e26b27"
        },
        secondary: {
            main: "#babfc3"
        },
        tertiary: {
            main: "#ffc600"
        },
        common: {
            white: "#fff"
        },
        default: {
            main: "#babfc3"
        }
    },
    typography: {
        fontFamily: ["Cabin", "sans-serif"].join(",")
    },
    components: {
        MuiButton: {
            styleOverrides: {
                /** Theming structure */
                containedDefault: {
                    background: "#babfc3",
                    color: "#fdf5f0"
                },
                containedPrimary: {
                    color: "#fff"
                },
                outlinedPrimary: {
                    color: "#e26b27"
                },
                containedSecondary: {
                    color: "#fff"
                },
                outlinedSecondary: {
                    color: "#babfc3"
                },
                containedError: {
                    background: "#ee315e",
                    color: "#fff"
                },
                outlinedError: {
                    color: "#ee315e"
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                columnHeaders: {
                    color: "#e26b27",
                    "&  svg": {
                        color: "#e26b27"
                    }
                },
                footerContainer: {
                    "& svg": {
                        color: "#e26b27"
                    }
                }
            }
        }
    },
    overrides: {},
    shape: {
        borderRadius: 1
    }
};
